<template lang="html">
  <div>
    <div>
      <span class="title-boss">Datos del Propietario:</span>
      <div class="boss-content">
        <span><b>{{ enterprise.nombre }}</b></span>
        <span v-if="enterprise.identificacion"><b>{{ typeDoc }}</b>: {{ enterprise.identificacion }}</span>
        <span v-if="enterprise.matricula"><b>Matricula</b>: {{ enterprise.matricula }}</span>
        <span><b>Organización</b>: {{ typeOrg }}</span>
        <nav
          v-if="enterprise.estado"
          :class="{
            'active' : enterprise.estado == '00' || enterprise.codigo_estado == '01' || enterprise.estado == 'Activo' || enterprise.estado == 'MA',
            'suspension' : enterprise.estado == '01' || enterprise.codigo_estado == '03' || enterprise.estado == '03' || enterprise.codigo_estado == '15' || enterprise.estado == 'Suspendido' || enterprise.estado == 'MI' || enterprise.estado == 'MF' || enterprise.estado == 'MC' || enterprise.estado == 'NA',
            'pending' : enterprise.estado == '04' || enterprise.estado == 'Pendiente Actualización' || enterprise.estadodatosmatriculatextual == 'EN DIGITACIÓN' || enterprise.estadodatosmatriculatextual == 'DOC. TRÁMITE' || enterprise.estadodatosmatriculatextual == 'POR VERIFICAR'
          }">
          <div class="tags has-addons">
            <span class="tag">Estado</span>
            <span class="tag status">{{ title }}</span>
          </div>
        </nav>
      </div>
    </div>
    <span class="title-boss">Credenciales:</span>
    <carousel
      :loop="true"
      :perPage="1"
      :perPageCustom="[[768, 3]]"
      paginationActiveColor="#fbdb41"
      :navigationEnabled="true">
      <slide v-for="(e, index) in certifies" :key="index" class="slider-container">
        <a class="bussiness" :href="e.url" target="_blank">
          <span class="name">{{ e.name }}</span>
          <div class="medal">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 511.76 511.76" xml:space="preserve"><polygon points="151.352,221.248 39.592,431.808 141.08,422.432 190.2,511.744 301.96,301.184 " style="fill: rgb(233, 84, 84);"></polygon> <g><path d="M164.152,450.432c3.136-6.736-0.144-14.784-6.704-18.272l-6.432-3.424
            		c-6.432-3.664-8.88-11.808-5.376-18.4c3.552-6.704,11.904-9.264,18.608-5.712l18.176,9.648c5.616,2.976,12.656,0.816,15.552-4.832
            		l0.448-0.864c3.328-5.328,1.36-12.368-4.176-15.296l-54.368-28.848c-6.624-3.52-9.872-11.536-6.784-18.288
            		c3.408-7.184,12.016-10.016,18.944-6.336l50.432,26.768c5.616,2.976,12.656,0.816,15.632-4.8l0.288-0.736l0.08-0.16
            		c3.216-5.888,0.96-13.28-4.976-16.432l-28.288-15.008c-6.624-3.52-9.872-11.536-6.736-18.368
            		c3.376-7.104,12.016-10.016,18.944-6.336l31.248,16.592c5.84,3.104,12.816,0.512,15.84-5.376c0.048-0.08,0.048-0.08,0.08-0.16
            		c0.048-0.08,0.048-0.08,0.08-0.16c3.184-5.808,1.424-13.04-4.432-16.128l-33.712-17.888c-6.544-3.472-9.792-11.488-6.704-18.24
            		c3.408-7.184,12.016-10.016,18.944-6.336l83.168,44.144l-111.76,210.56l-30.8-55.984
            		C161.352,454.416,163.08,452.752,164.152,450.432z" style="fill: rgb(237, 99, 98);"></path> <polygon points="360.408,221.248 472.168,431.808 370.68,422.432 321.56,511.744 209.8,301.184 	" style="fill: rgb(237, 99, 98);"></polygon></g> <path d="M347.608,450.432c-3.136-6.736,0.144-14.784,6.704-18.272l6.432-3.424
            	c6.432-3.664,8.88-11.808,5.376-18.4c-3.552-6.704-11.904-9.264-18.608-5.712l-18.176,9.648c-5.616,2.976-12.656,0.816-15.552-4.832
            	l-0.448-0.864c-3.328-5.328-1.36-12.368,4.176-15.296l54.384-28.864c6.624-3.52,9.872-11.536,6.784-18.288
            	c-3.408-7.184-12.016-10.016-18.944-6.336l-50.432,26.768c-5.616,2.976-12.656,0.816-15.632-4.8l-0.288-0.736l-0.08-0.16
            	c-3.216-5.888-0.96-13.28,4.976-16.432l28.288-15.008c6.624-3.52,9.872-11.536,6.736-18.368
            	c-3.376-7.104-12.016-10.016-18.944-6.336l-31.28,16.624c-5.84,3.104-12.816,0.512-15.84-5.376c-0.048-0.08-0.048-0.08-0.08-0.16
            	c-0.048-0.08-0.048-0.08-0.08-0.16c-3.184-5.808-1.424-13.04,4.432-16.128l33.712-17.888c6.544-3.472,9.792-11.488,6.704-18.24
            	c-3.408-7.184-12.016-10.016-18.944-6.336L209.816,301.2l111.76,210.56l30.8-55.984C350.408,454.416,348.68,452.752,347.608,450.432
            	z" style="fill: rgb(233, 84, 84);"></path> <circle cx="255.88" cy="186.736" r="186.736" style="fill: rgb(255, 204, 91);"></circle> <path d="M281.208,165.312H162.872c-9.2,0-16.752-7.552-16.752-16.752l0.128-1.152v-0.256
            	c-0.128-9.712,7.792-17.648,17.52-17.648h82.016c10.864,0,20.464-8.048,21.104-18.928C267.4,99.2,258.328,89.6,246.936,89.6h-86.88
            	c-9.584,0-16.752-8.048-16.624-17.648c0-0.128,0-0.128,0-0.256s0-0.128,0-0.256c-0.128-9.584,7.024-17.648,16.624-17.648h90.912
            	c10.736,0,20.336-8.048,20.976-18.8c0.512-11.504-8.56-20.976-19.952-20.976h-66.576C117.528,42,69.688,108.752,69.688,186.736
            	s47.84,144.72,115.744,172.672h84.528c10.736,0,20.336-8.048,20.976-18.8c0.512-11.504-8.56-20.96-19.952-20.96l-96.16-0.016
            	c-11.344,0-20.48-9.488-19.872-20.976c0.56-10.752,10.224-18.832,20.992-18.832h37.28c10.72-0.304,19.376-9.088,19.376-19.888
            	c0-10.992-8.944-19.952-19.952-19.952h-56.512c-9.2,0-16.752-7.536-16.624-16.752v-1.408c-0.64-9.072,6.656-16.752,15.728-16.752
            	h124.816c10.864,0,20.464-8.048,21.104-18.8C301.672,174.784,292.584,165.312,281.208,165.312z" style="fill: rgb(253, 188, 75);"></path> <path d="M255.88,320.016c-73.504,0-133.296-59.808-133.296-133.296S182.376,53.44,255.88,53.44
            	s133.296,59.808,133.296,133.296S329.384,320.016,255.88,320.016z" style="fill: rgb(255, 219, 112);"></path> <path d="M389.176,186.736c0-70.912-55.712-128.912-125.648-132.912
            	h-12.416c-8.192,0-15.504,6.144-16,14.336c-0.384,8.768,6.528,16,15.216,16l73.344,0.016c8.656,0,15.616,7.232,15.152,16
            	c-0.432,8.208-7.792,14.368-16.016,14.368h-28.432c-8.176,0.24-14.784,6.928-14.784,15.168c0,8.384,6.832,15.216,15.216,15.216
            	h43.104c7.024,0,12.768,5.76,12.672,12.768v1.056c0.48,6.928-5.072,12.768-12,12.768H243.4c-8.288,0-15.6,6.144-16.096,14.336
            	c-0.384,8.768,6.528,16,15.216,16h90.24c7.024,0,12.768,5.76,12.768,12.768l-0.096,0.88v0.192
            	c0.096,7.408-5.952,13.456-13.36,13.456h-62.56c-8.288,0-15.6,6.144-16.096,14.432c-0.384,8.672,6.528,16,15.216,16h66.256
            	c7.312,0,12.768,6.144,12.672,13.456c0,0.096,0,0.096,0,0.192c0,0.096,0,0.096,0,0.192c0.096,7.312-5.36,13.456-12.672,13.456
            	H265.56c-8.192,0-15.504,6.144-16,14.336c-0.384,8.784,6.528,16,15.216,16h18.288C343.592,304.608,389.176,250.896,389.176,186.736z
            	" style="opacity: 0.2; fill: rgb(255, 255, 255);"></path> <path d="M348.936,157.216h-64.832l-20.048-61.664c-2.576-7.92-13.792-7.92-16.368,0l-20.032,61.664h-64.832
            	c-8.336,0-11.808,10.672-5.056,15.568l52.448,38.112l-20.032,61.664c-2.576,7.92,6.496,14.512,13.248,9.616l52.448-38.112
            	l52.448,38.112c6.752,4.896,15.824-1.696,13.248-9.616l-20.032-61.664l52.448-38.112
            	C360.728,167.888,357.272,157.216,348.936,157.216z" style="fill: rgb(236, 153, 34);"></path></svg>
          </div>
          <div class="qr-container">
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve">
              <g>
              	<g>
              		<g>
              			<path d="M160,0H0v160h160V0z M128,128H32V32h96V128z"/>
              			<rect x="64" y="64" width="32" height="32"/>
              			<path d="M352,0v160h160V0H352z M480,128h-96V32h96V128z"/>
              			<rect x="416" y="64" width="32" height="32"/>
              			<path d="M0,512h160V352H0V512z M32,384h96v96H32V384z"/>
              			<rect x="64" y="416" width="32" height="32"/>
              			<rect x="256" width="64" height="32"/>
              			<polygon points="256,128 288,128 288,96 320,96 320,64 224,64 224,32 192,32 192,64 192,80 192,96 256,96 			"/>
              			<rect x="192" y="128" width="32" height="32"/>
              			<polygon points="320,160 288,160 288,192 192,192 192,224 320,224 			"/>
              			<polygon points="32,288 64,288 64,256 32,256 32,192 0,192 0,320 32,320 			"/>
              			<rect x="64" y="192" width="32" height="32"/>
              			<polygon points="192,320 256,320 256,288 224,288 224,256 160,256 160,192 128,192 128,256 96,256 96,320 128,320 128,288
              				144,288 160,288 192,288 			"/>
              			<rect x="288" y="256" width="32" height="64"/>
              			<polygon points="288,352 192,352 192,384 256,384 256,480 192,480 192,512 288,512 288,480 352,480 352,448 288,448 			"/>
              			<rect x="192" y="416" width="32" height="32"/>
              			<rect x="320" y="352" width="32" height="64"/>
              			<polygon points="480,416 384,416 384,512 416,512 416,448 480,448 			"/>
              			<rect x="448" y="480" width="64" height="32"/>
              			<rect x="480" y="352" width="32" height="32"/>
              			<polygon points="384,384 416,384 416,288 352,288 352,320 384,320 			"/>
              			<polygon points="448,224 416,224 416,192 384,192 384,224 352,224 352,256 480,256 480,224 512,224 512,192 448,192 			"/>
              			<rect x="448" y="288" width="64" height="32"/>
              		</g>
              	</g>
              </g>
            </svg>
          </div>
          <span class="year">{{ getYear }}</span>
        </a>
      </slide>
    </carousel>
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel'

export default {
  props: {
    enterprise: Object,
  },
  data() {
    return {
      is_business_establishment: false,
      certifies: [],
      count: 0
    }
  },
  components: {
    Carousel,
    Slide
  },
  methods: {
    findCert() {
      let vm = this
      _.find(vm.enterprise.establecimientos, function (e) {
        vm.is_business_establishment = false
        const year = parseInt(e.ultanorenovado)
        if (year == moment().year()) {
          vm.getCert(e.matricula)
          vm.count++
        }
      })
      if (vm.enterprise.organizacion == '02' || vm.enterprise.categoria == '2' || vm.enterprise.categoria == '3') {
        vm.is_business_establishment = true
        const year = parseInt(vm.enterprise.ultanorenovado)
        if (year == moment().year()) {
          vm.getCert(vm.enterprise.matricula)
          vm.count++
        }
      }
    },
    getCert(m) {
      let vm = this
      axios.post('https://control.ccmonteria.org.co/api/site/certificadoRenovacion',
      {
        matricula: m
      })
      .then(function (response) {
        const r = response.data.data
        let cer_o = {
          name: r.nombre,
          url: decodeURI(r.UrlCertificado)
        }
        vm.certifies.push(cer_o)
      })
      .catch(function (error) {
        console.log(error)
        vm.$root.message = 'Ha ocurrido un error en el servidor, vuelva a consultar por favor.'
        vm.$root.toast()
      })
    },

  },
  computed: {
    getYear() {
      return moment().year()
    },
    title() {
      switch (this.enterprise.estado) {
        case 'MA':
          return 'Activa'
        case 'MI':
          return 'Inactiva'
        case 'MF':
          return 'Cancelada por cambio de jurisdicción'
        case 'MC':
          return 'Cancelada'
        case 'NA':
          return 'No asignada o anulada'
        case '00':
          return 'Activa'
        case '01':
          return 'Cancelada'
        case '03':
          return 'Cancelada'
        case '04':
          return 'Cesada'
        default:
          return ''
      }
    },
    typeOrg() {
      switch (this.enterprise.organizacion) {
        case '01':
        return 'Persona Natural'
        case '02':
        return 'Establecimiento de Comercio'
        case '03':
        return 'Sociedad Limitada'
        case '04':
        return 'Sociedad Anónima'
        case '05':
        return 'Sociedad Colectiva'
        case '06':
        return 'Sociedad Comandita Simple'
        case '07':
        return 'Sociedad Comandita por Acciones'
        case '08':
        return 'Sociedad Extranjera'
        case '09':
        return 'Empresa Asociativa de Trabajo'
        case '10':
        return 'Sociedad Civil'
        case '11':
        return 'Empresa Unipersonal'
        case '12':
        return 'Entidad Sin Animo de Lucro'
        case '14':
        return 'Entidad de Economía Solidaria'
        case '15':
        return 'Empresa Industrial y Comercial del Estado'
        case '16':
        return 'Sociedad por Acciones Simplificada'
        case '17':
        return 'Agrarias de transformación'
        case '99':
        return 'Otras (personas jurídicas)'
        default:
        return ''
      }
    },
    typeDoc() {
      switch (this.enterprise.idclase) {
        case '1':
        return 'CC'
        case '2':
        return 'NIT'
        case '3':
        return 'case'
        case '4':
        return 'TI'
        case '5':
        return 'PA'
        case '6':
        return 'PJ'
        case 'E':
        return 'DE'
        case 'R':
        return 'RC'
        default:
        return ''
      }
    },
  },
  mounted() {
    let vm = this
    vm.findCert()
  }
}
</script>

<style lang="sass">
  .has-addons
    margin-top: 5px
  .title-boss
    font-size: 20px
    font-weight: bold
    display: block
    margin-bottom: 20px
  .boss-content
    display: flex
    flex-direction: column
    margin-bottom: 20px
    border-bottom: 1px solid #efefef
    padding: 0 20px 20px 20px
  .VueCarousel-navigation-button
    color: #fff !important
    font-size: 25px
    outline: none
    top: 35%
  .qr-container
    position: absolute
    width: 20px
    bottom: 10px
    left: 10px
    z-index: 1
  .medal
    width: 40px
    position: absolute
    top: 20px
    & svg
      width: 100%
  .slider-container
    &:not(:first-of-type)
      & .bussiness
        margin-left: 15px
  .bussiness
    background: #fff
    padding: 1em
    border-radius: 5px
    border: 0
    color: #4a4a4a
    font-weight: bold
    text-align: center
    height: 180px
    display: flex
    justify-content: center
    align-items: center
    position: relative
    flex-direction: column
    animation: .5s fade-in-card ease
    border: 1px solid rgba(24, 118, 209, 0.49)
    &:before
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 40px
      height: 40px
      background-color: #1976D2
      background-image: url(../../images/cloud-computing.svg)
      background-size: 25px
      background-repeat: no-repeat
      background-position: 4px 5px
      border-radius: 5px 0px 61px 0px
    &:after
      background: url(../../images/miniature.jpg)
      content: ''
      width: 100%
      height: 100%
      top: 0
      left: 0
      background-size: cover
      position: absolute
      opacity: 0
    &:after, &:before
      transition: all .3s ease
    &:hover
      &:after
        opacity: 1
      &:before
        width: 100%
        height: 100%
    & .name
      position: absolute
      top: 43%
      z-index: 1
      display: -webkit-box
      -webkit-font-smoothing: antialiased
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      overflow: hidden
      padding: 0 10px
    & .year
      font-size: 1.5rem
      z-index: 1
      position: absolute
      bottom: 0%
</style>



// WEBPACK FOOTER //
// resources/js/components/ShowEnterprise.vue